import { highlightLogRecordText } from '@/utils/helper'

export default {
  getLogRecords: (state) => {
    return state.logRecords.map(log => {
      return highlightLogRecordText(log)
    })
  }
}
